var map = {
	"./footer.blocks/@TEMPLATE/Settings": [
		28573,
		8573
	],
	"./footer.blocks/FOOTER_Nav_Simple/Settings": [
		13311,
		4185,
		8908,
		2432,
		9797
	],
	"./header.blocks/@TEMPLATE/Settings": [
		78031,
		8031
	],
	"./header.blocks/HEADER_Nav_Simple/Settings": [
		95239,
		4185,
		8908,
		2432,
		8655,
		6557
	],
	"./page.blocks/@TEMPLATE/Settings": [
		36393,
		6393
	],
	"./page.blocks/BLUESKY_001/Settings": [
		83932,
		4185,
		8908,
		2432,
		8655,
		6853,
		4234
	],
	"./page.blocks/CATALOGUE_001/Settings": [
		78020,
		4185,
		8908,
		2432,
		8655,
		6853,
		1770
	],
	"./page.blocks/COVER_001/Settings": [
		97746,
		4185,
		8908,
		2432,
		8655,
		6593,
		7746
	],
	"./page.blocks/DOCS_PREVIEW_001/Settings": [
		67161,
		4185,
		8908,
		2432,
		8655,
		4275,
		4081
	],
	"./page.blocks/Filter_001/Settings": [
		72883,
		4185,
		8908,
		2432,
		8655,
		6593,
		4275,
		2883
	],
	"./page.blocks/MENU_001/Settings": [
		3580,
		4185,
		8908,
		2432,
		3577,
		5212
	],
	"./page.blocks/SHOPPING_CALL_001_Block/Settings": [
		97890,
		4185,
		8908,
		2432,
		8655,
		9471
	],
	"./page.blocks/SPACER_001/Settings": [
		9557,
		4185,
		8908,
		2432,
		8655,
		6593,
		9557
	],
	"./page.blocks/Search_001/Settings": [
		74417,
		4185,
		8908,
		2432,
		8655,
		6593,
		4417
	],
	"./page.blocks/TEXT_AND_IMAGE_001/Settings": [
		91612,
		3577,
		1612
	],
	"./page.blocks/TEXT_AND_IMAGE_002/Settings": [
		54015,
		6853,
		466
	],
	"./page.blocks/TWITTER_001/Settings": [
		57278,
		4185,
		8908,
		2432,
		8655,
		6593,
		7278
	],
	"./page.blocks/Table_001/Settings": [
		13243,
		4185,
		8908,
		2432,
		8655,
		6853,
		5177
	],
	"./page.blocks/YOUTUBE_001/Settings": [
		19952,
		4185,
		8908,
		2432,
		8655,
		6593,
		9952
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 59416;
module.exports = webpackAsyncContext;